<template>
	<div id="editMyCenter">
		<div class="uploadImg" @click="chooseType">
			<img v-show="!Teamfrom.Photo" class="Photo"  src="../assets/zanwu.jpg" alt="">
			<img class="Photo" v-if='Teamfrom.Photo' :src="Teamfrom.RootPath+Teamfrom.Photo" alt="">
		</div>
		<input id="upload_file" type="file" class="file-input" accept="image/*" :multiple="multiple"
		 @change="inputChange" style="display: none" />
		<div class="UserName_box">
			<span style="color: #f00;">*</span>
			<input type="text" readonly="readonly" class="UserName" v-model="Teamfrom.TeamName">
		</div>
		<div class="list">
			<div class="list_left">
				<!-- <span style="color: #f00;">*</span> -->
				<span>机构名称</span>
			</div>
			<input type="text" v-model="Teamfrom.TeamOrg" placeholder="如:XX银行XX支行">
		</div>
		<div class="list">
			<div class="list_left">
				<!-- <span style="color: #f00;">*</span> -->
				<span>所在地区</span>
			</div>
			<input type="text" @click="popupVisible = !popupVisible" readonly="readonly" v-model="Teamfrom.Province+'-'+Teamfrom.City"
			 placeholder="请选择地区">
		</div>
		<div class="list">
			<div class="list_left">
				<!-- <span style="color: #f00;">*</span> -->
				<span>参赛宣言</span>
			</div>
			<input type="text" v-model="Teamfrom.TeamDeclaration" placeholder="不超过25个字">
		</div>
		<mt-popup v-model="popupVisible" position="bottom" style='width: 100%;'>
			<mt-picker :slots="slots" value-key='label' toolbar="1,2" @change="onChange">
			</mt-picker>
		</mt-popup>
		<div class="Introduction_title">团队简介</div>
		<textarea name="" id="" v-model="Teamfrom.Introduction" maxlength="300" placeholder="最多300字" class="Introduction_text"></textarea>
		<div style="height: 40px;"></div>
		<div class="operation" @click="savefun()">
			保存
		</div>
	</div>

</template>

<script>
	import {Indicator,MessageBox} from 'mint-ui';
	export default {
		data() {
			return {
				value:[],
				toolbar: '',
				popupVisible: false,
				Provincecity: '',
				columns: [],
				Teamfrom: {
					ProvinceId: 0,
					CityId: '',
					TeamDeclaration: '',
					Introduction: '',
					TeamOrg: 0,
					Photo:'',
				},
				slots: [{
					flex: 1,
					values: [],
					value: "北京",
					className: 'slot1',
					textAlign: 'center'
				}, {
					divider: true,
					content: '-',
					className: 'slot2'
				}, {
					flex: 1,
					values: [],
					className: 'slot3',
					textAlign: 'center'
				}]
			}
		},
		beforeCreate(){
			var competition_cookie = localStorage.getItem("competition_cookie")
			console.log(competition_cookie)
			if(competition_cookie){
				
			}else{
				MessageBox('提示', '请先登录！');
				this.$router.push('/login');
				
			}
		},
		created() {
			this.getProvince()
			this.getmember()
		},
		props: {
			multiple: false,
			max: 1,
		},
		methods: {
			// 上传图片
			chooseType() {
				document.getElementById("upload_file").click();
			},
			async inputChange(e) {
				let files = e.target.files;
				console.log(files)
				let uploadAll = [].slice.call(files, 0).map(this.upload);
				//使用object.values(files)，测试安卓存在兼容性问题，替换为[].slice.call(files ,0)
				console.log(uploadAll)
				Indicator.open('加载中...');
				let result = await Promise.all(uploadAll);
				document.getElementById("upload_file").value = "";
			},
			upload(file, index) {
				console.log(file)
				return new Promise(async (resolve, reject) => {
					let form = new FormData();
					form.append("file", file);
					let result = this.$http.post("/api/member/UploadPhoto", form)
						.then(response => {
							console.log(response)
							if(response.data.Success){
								console.log(response.data.data[0])
								this.Teamfrom.Photo = response.data.data[1]
							}else{
								MessageBox('提示', response.data.ErrorMsg);
							}
							
							// this.list = response.data.data[0]
							Indicator.close();
						}).catch(error => {
							console.log(error)
						});
				});
			},
			// 上传结束
			getmember() {
				this.$http.get('/api/team/GetOrg')
					.then(res => {
						for (let x in res.data.data.Members) {
							console.log(res.data.data.Members[x].CertIds)
							var reg = /[\u4e00-\u9fa5]/g;
							var str = res.data.data.Members[x].CertIds ? res.data.data.Members[x].CertIds : '';
							res.data.data.Members[x].CertIds = str.replace(reg, "");
						}
						this.Teamfrom = res.data.data
						if (this.Teamfrom.ProvinceId) {
							this.getProvinceCity()
						}
						console.log(this.Teamfrom)
					})
					.catch(error => {
						console.log(error)
					})
			},
			getProvince() {
				var url = '/api/ProvinceCity/GetList'
				this.$http.get(url)
					.then(res => {
						for (let x in res.data.data) {
							this.slots[0].values.push(res.data.data[x])
						}
						this.picker = 1
						this.getProvinceCity();
					})
					.catch(error => {
						console.log(error)
					})
			},
			getProvinceCity() {

				var url = '/api/ProvinceCity/GetList?Id=' + this.Teamfrom.ProvinceId

				this.$http.get(url)
					.then(res => {
						this.slots[2].values = []
						for (let x in res.data.data) {
							this.slots[2].values.push(res.data.data[x])
						}
					})
					.catch(error => {
						console.log(error)
					})
			},
			onChange(picker, values) {
				console.log(1)
				if (values[0] !== values[1]) {
					console.log(picker.getSlotValue(0))
					console.log(picker.getSlotValue(1))
					this.Teamfrom.ProvinceId = picker.getSlotValue(0) && picker.getSlotValue(0).value ? picker.getSlotValue(0).value :
						this.Teamfrom.ProvinceId;
					this.Teamfrom.CityId = picker.getSlotValue(1) && picker.getSlotValue(1).value ? picker.getSlotValue(1).value : this.Teamfrom
						.CityId;
					this.getProvinceCity()
					this.Teamfrom.Province = picker.getSlotValue(0) && picker.getSlotValue(0).value ? picker.getSlotValue(0).label :
						this.Teamfrom.Province
					this.Teamfrom.City = picker.getSlotValue(1) && picker.getSlotValue(1).value ? picker.getSlotValue(1).label : this.Teamfrom.City;
					// this.Provincecity = picker.getSlotValue(0).label + '-' + picker.getSlotValue(1).label
				}
			},
			savefun() {
				console.log(this.Teamfrom)
				this.$http.post('/api/team/TeamUpdate', this.Teamfrom)
					.then(res => {
						console.log(res)
						if (res.data.Success) {
							MessageBox('提示', '保存成功');
							this.$router.go(-1)
						} else {
							MessageBox('提示', res.data.ErrorMsg);
						}
					})
					.catch(error => {
						console.log(error)
					})
			},
		}
	}
</script>

<style scoped="scoped" lang="scss">
	.picker-toolbar-title {
		display: flex;
		height: 100%;
		align-items: center;
		justify-content: space-between;

		.usi-btn-sure,
		.usi-btn-cancel {
			padding: 0 20px;
		}
	}

	.operation {
		position: fixed;
		width: 100%;
		height: 40px;
		line-height: 40px;
		background: #3E1976;
		bottom: 0;
		left: 0;
		color: #fff;
		text-align: center;
		// .personal {
		// 	background: #fff;
		// 	color: #3E1976;
		// 	border: 1px solid #3E1976;
		// 	height: 40px;
		// 	line-height: 40px;
		// }
	}

	#editMyCenter {
		padding: 1rem 0.8rem;
		box-sizing: border-box;

		.Introduction_title {
			text-align: center;
			font-size: 1rem;
			margin: 1rem 0;
		}

		.Introduction_text {
			width: 100%;
			height: 13rem;
			border: none;
			border: 1px solid #dbdcdd;
		}

		.uploadImg {
			width: 7.5rem;
			height: 9rem;
			background: #dbdcdd;
			display: flex;
			align-items: center;
			margin: 0 auto;
			overflow: hidden;
			.Photo {
				width: 100%;
			}
		}

		.UserName_box {
			text-align: center;
			margin-bottom: 20px;

			.UserName {
				width: 6rem;
				font-size: 1rem;
				text-align: center;
				border: none;
				border-bottom: 1px solid #dbdcdd;
				margin-top: 10px;
			}
		}

		.list {
			display: flex;
			align-items: center;
			font-size: 0.9rem;
			margin-top: 10px;

			.list_left {
				margin-right: 10px;
			}

			input {
				flex: 1;
				height: 2rem;
				line-height: 2rem;
				border: none;
				border: 1px solid #dbdcdd;
				padding: 0 0.5rem;
				border-radius: 5px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/editTeam.vue